<template>
  <div class="user_container">
    <div class="user-concent">
      <div class="con-top"></div>
      <div class="con-img-qua">
        <!-- <div class="title">2024年度</div> -->
        <img
          v-if="quarter == '一'"
          src="@/assets/medal/quarterOne.png"
          alt=""
        />
        <img
          v-if="quarter == '二'"
          src="@/assets/medal/quarterTwo.png"
          alt=""
        />
        <img
          v-if="quarter == '三'"
          src="@/assets/medal/quarterThree.png"
          alt=""
        />
        <img
          v-if="quarter == '四'"
          src="@/assets/medal/quarterFour.png"
          alt=""
        />
      </div>
      <div class="con-img-time">{{ startTime }}-{{ endTime }}</div>
      <div class="con-content">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="nominee">
            <br />
            <el-input
              v-model="ruleForm.nominee"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门" prop="nominDept">
            <br />
            <el-input
              v-model="ruleForm.nominDeptStr"
              placeholder="请选择部门"
              @focus="changeDepament"
            ></el-input>
            <!-- <el-select
              v-model="ruleForm.nominDept"
              filterable
              placeholder="请选择部门"
            >
              <el-option
                v-for="item in columns"
                :key="item.id"
                :label="item.departmentName"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="工号" prop="empNo">
            <br />
            <el-input
              v-model="ruleForm.empNo"
              placeholder="请输入工号"
            ></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="nominType">
            <br />
            <el-radio-group v-model="ruleForm.nominType">
              <el-radio-button
                style="margin-right: 30px; border-radius: 4px"
                label="1"
                >个人</el-radio-button
              >
              <el-radio-button
                style="border-left: 1px solid #dcdfe6; border-radius: 4px"
                label="2"
                >团体</el-radio-button
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="被提名人/团队" prop="nominated">
            <br />
            <el-input
              v-model="ruleForm.nominated"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="提名标准" prop="nominStandard">
            <br />
            <van-field
              readonly
              clickable
              name="picker"
              :value="ruleForm.nominStandard"
              placeholder="请选择提名标准"
              @click="showPickerNate = true"
              right-icon="arrow-down"
            />
            <van-popup v-model="showPickerNate" position="bottom">
              <van-picker
                show-toolbar
                :columns="columnsNate"
                @confirm="onConfirmNate"
                @cancel="showPickerNate = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="主要成果" prop="achievement">
            <br />
            <el-input
              v-model="ruleForm.achievement"
              placeholder="请输入具体成果"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="事迹概述" prop="deedRemark">
            <br />
            <el-input
              v-model="ruleForm.deedRemark"
              placeholder="请输入具体事迹"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="提名人推荐语" prop="recommendation">
            <br />
            <el-input
              v-model="ruleForm.recommendation"
              placeholder="请输入提名人推荐语"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="报名表" class="download">
            <div>
              <span @click="onDownPpt">
                <img src="@/assets/medal/down.png" alt="" />下载ppt模板</span
              >
              <span @click="onDownExcel">
                <img src="@/assets/medal/down.png" alt="" />下载excel模板</span
              >
            </div>
          </el-form-item>
          <el-form-item
            label="导入文件（文件大小不能大于20MB）"
            class="leading"
          >
            <br />
            <div>
              <van-uploader
                :max-count="1"
                :after-read="afterOne"
                accept=".ppt,.pptx,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                :max-size="20480 * 1024"
              >
                <van-button icon="plus" type="primary">导入PPT文件</van-button>
              </van-uploader>
              <div
                class="leadingSpan"
                v-for="item in fileListOne"
                :key="item.name"
              >
                <span href="" class="a" @click="lookPPT">{{ item.name }}</span
                ><van-icon name="close" @click="closeFileOne" />
                <el-progress v-if="flagPpt" :percentage="70" />
              </div>
            </div>
            <div>
              <van-uploader
                :max-count="1"
                :after-read="afterTwo"
                accept=".xlsx,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                :max-size="20480 * 1024"
              >
                <van-button icon="plus" type="primary"
                  >导入excel文件</van-button
                >
              </van-uploader>
              <div
                class="leadingSpan"
                v-for="item in fileListTwo"
                :key="item.name"
              >
                <span href="" class="a" @click="lookExcel">{{ item.name }}</span
                ><van-icon name="close" @click="closeFileTwo" />
                <el-progress v-if="flagExcel" :percentage="70" />
              </div>
            </div>
          </el-form-item>
          <!-- <el-form-item label="审批流">
            <div class="container_item">
              <div>
                <div
                  class="handle"
                >
                  <div class="handleDiv">
                    <img
                      src="@/assets/car/handle.png"
                      alt=""
                      srcset=""
                      style="width: 27px; height: 27px"
                    />
                  </div>
                  <div class="handleRight">
                    <h3 class="rightTitle">
                      审批人
                    </h3>
                    <div class="approver">
                      <div class="approverImg">

                        <span class="clr-span">
                        人
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="handle"
                >
                  <div class="handleDiv">
                    <img
                      src="@/assets/car/handle.png"
                      alt=""
                      srcset=""
                      style="width: 27px; height: 27px"
                    />
                  </div>
                  <div class="handleRight">
                    <h3 class="rightTitle">
                      审批人
                    </h3>
                    <div class="approver">
                      <div class="approverImg">

                        <span class="clr-span">
                        人
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="menu"></div>
    <div class="foot-btn">
      <van-button
        style="background: rgba(243, 243, 243, 1)"
        @click="$router.go(-1)"
        >取消</van-button
      >
      <van-button
        style="background: rgba(78, 162, 124, 1); color: #fff"
        @click="submit('ruleForm')"
        :disabled="btnLoading"
        >确认</van-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import { downloadExcel } from "@/utils/tools";
import { Base64 } from "js-base64";
import moment from "moment";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      showPicker: false,
      showPickerNate: false,
      stateType: "",
      fileListOne: [],
      fileListTwo: [],
      ruleForm: {
        nominee: "",
        nominDept: "",
        nominDeptStr: "",
        empNo: "",
        nominType: "1",
        nominated: "",
        nominStandard: "",
        achievement: "",
        deedRemark: "",
        recommendation: "",
        pptId: "",
        excelId: ""
      },
      pptName: "",
      excelName: "",
      rules: {
        nominee: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        nominDept: [{ required: true, message: "请选择部门", trigger: "blur" }],
        empNo: [{ required: true, message: "请输入工号", trigger: "blur" }],
        nominated: [
          { required: true, message: "请输入被提名人/团队", trigger: "blur" }
        ],
        nominType: [{ required: true, message: "请选择类型", trigger: "blur" }],
        nominStandard: [
          { required: true, message: "请选择提名标准", trigger: "blur" }
        ]
      },
      // columns: [],
      columnsNate: [],
      id: "",
      depamentId: "",
      flagPpt: false,
      flagExcel: false,
      isHR: "",
      lookExcelName: "",
      lookPPTName: "",
      year: "",
      quarter: "",
      startTime: "",
      endTime: "",
      btnLoading: false,
      empNo: "",
      pptOaInfo: {},
      excelOainfo: {}
    };
  },
  created() {},
  mounted() {
    // this.getDepament();
    let hrToken = getToken();
    if (hrToken) {
      this.empno = hrToken;
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
        });
      });
    }

    this.getType();
    this.id = this.$route.query.id;
    this.queryById(this.id);
    this.isHR = this.$route.query.isHR;
    // if (this.$store.state.infoMedal) {
    this.ruleForm = this.$store.state.infoMedal;
    this.$store.state.infoMedal.pptName &&
      this.fileListOne.push({ name: this.$store.state.infoMedal.pptName });
    this.$store.state.infoMedal.excelName &&
      this.fileListTwo.push({ name: this.$store.state.infoMedal.excelName });
    // }
    let depament = JSON.parse(localStorage.getItem("depament"));
    if (depament) {
      let str = [];
      let arr = [];
      depament &&
        depament.forEach(item => {
          arr.push(item.id);
          str.push(item.departmentName);
          this.ruleForm.nominDept = arr.join(",");
          this.ruleForm.nominDeptStr = str.join(",");
        });
    }
    // this.year = moment(new Date()).format('YYYY')
  },
  methods: {
    // 获取hrToken&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            // console.log(data);
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //获取详情
    queryById(id) {
      api.medalTaskQueryById({ id: id }).then(res => {
        console.log(res, "res");
        const data = res.data;
        this.year =
          data.reviewStartTime && moment(data.reviewStartTime).format("YYYY");
        this.quarter = this.convertToChinese(
          moment(data.reviewStartTime).quarter()
        );
        this.startTime = moment(data.reviewStartTime).format("MM月DD日");
        this.endTime = moment(data.reviewEndTime).format("MM月DD日");
      });
    },
    //转换数字为中文
    convertToChinese(num) {
      const N = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      const str = num.toString();
      const len = num.toString().length;
      const C_Num = [];
      for (let i = 0; i < len; i++) {
        C_Num.push(N[str.charAt(i)]);
      }
      return C_Num.join("");
    },
    //选择部门
    changeDepament() {
      this.$store.commit("changeInfoMedal", {
        ...this.ruleForm,
        pptName: this.pptName,
        excelName: this.excelName
      });
      this.$router.push({
        path: "/mobile/medal/depament",
        query: {
          id: this.ruleForm.nominDept
        }
      });
    },
    //上传文件
    afterOne(file) {
      this.lookPPTName = file.file.name;
      if (this.fileListOne.length > 0) {
        this.$message({
          type: "warning",
          message: "只能上传一个ppt",
          duration: 1000
        });
      } else {
        const files = [file];
        let params = new FormData();
        params.append("file", files[0].file);
        this.fileListOne.push({ name: file.file.name });
        this.flagPpt = true;

        const empno = this.empno;
        api.uploadNew(params).then(data => {
          this.ruleForm.pptId = data.data.id;
          this.pptName = file.file.name;
          this.flagPpt = false;
          params.append("empNo", empno);
          // api.oaUploadFileAPi(params).then(res => {
          //   this.pptOaInfo = {
          //     fileName: res.data.filename,
          //     filePath: "http://oa.nvc-lighting.com:8082" + res.data.loadlink,
          //     imageFileId: res.data.imagefileid
          //   };
          //   console.log("this.pptOaInfo", this.pptOaInfo);
          //   // filename loadlink
          // });
        });
      }
    },
    //获取提名标准
    getType() {
      const params = new FormData();
      params.append("type", "nominStandard");
      api.queryByType(params).then(data => {
        // this.columnsNate = data.data
        data.data.forEach(item => {
          this.columnsNate.push({ text: item.value, value: item.id });
        });
      });
    },
    //上传文件
    afterTwo(file) {
      this.lookExcelName = file.file.name;
      if (this.fileListTwo.length > 0) {
        this.$message({
          type: "warning",
          message: "只能上传一个excel",
          duration: 1000
        });
      } else {
        const files = [file];
        let params = new FormData();
        params.append("file", files[0].file);
        console.log("params", params);
        this.fileListTwo.push({ name: file.file.name });
        this.flagExcel = true;
        const empno = this.empno;
        api.uploadNew(params).then(data => {
          this.ruleForm.excelId = data.data.id;
          this.excelName = file.file.name;
          this.flagExcel = false;
          params.append("empNo", empno);
          // api.oaUploadFileAPi(params).then(res => {
          //   this.excelOainfo = {
          //     fileName: res.data.filename,
          //     filePath: "http://oa.nvc-lighting.com:8082" + res.data.loadlink,
          //     imageFileId: res.data.imagefileid
          //   };
          // });
        });
      }
    },
    //删除文件
    closeFileOne() {
      this.fileListOne = [];
    },
    //删除文件
    closeFileTwo() {
      this.fileListTwo = [];
    },
    //下载文件
    onDownPpt() {
      api.downPptx().then(data => {
        downloadExcel(data, "荣誉勋章评选汇报PPT", "ppt");
      });
    },
    //下载文件
    onDownExcel() {
      api.downExcel().then(data => {
        downloadExcel(data, "荣誉勋章评选汇报excel", "xlsx");
      });
    },
    //预览文件
    lookPPT() {
      console.log("111");
      // const src = `https://view.xdocin.com/view?src=https://qw.nvc-lighting.com.cn:8082/file/view/${this.ruleForm.pptId}`;
      // window.open(src, "_target");
      let pptName = this.lookPPTName.replace(/&|=|\?|\\/g, "");
      console.log(this.ruleForm, "this.ruleForm");
      var url = `http://qw.nvc-lighting.com.cn:8083/file/view/${this.ruleForm.pptId}?fullfilename=${this.ruleForm.pptId}${pptName}`; //要预览文件的访问地址
      window.open(
        "http://qw.nvc-lighting.com.cn:10000/onlinePreview?url=" +
          encodeURIComponent(Base64.encode(url))
      );
    },
    //预览文件
    lookExcel() {
      console.log(this.ruleForm);
      // const src = `https://view.xdocin.com/view?src=https://qw.nvc-lighting.com.cn:8082/file/view/${this.ruleForm.excelId}`;
      // window.open(src, "_target");
      let pptName = this.lookExcelName.replace(/&|=|\?|\\/g, "");
      var url = `http://qw.nvc-lighting.com.cn:8083/file/view/${this.ruleForm.excelId}?fullfilename=${this.ruleForm.excelId}${pptName}`; //要预览文件的访问地址
      window.open(
        "http://qw.nvc-lighting.com.cn:10000/onlinePreview?url=" +
          encodeURIComponent(Base64.encode(url))
      );
    },
    //确认提名标准
    onConfirmNate(value) {
      this.showPickerNate = false;
      this.ruleForm.nominStandard = value.text;
      this.stateType = value.value;
    },
    //提交
    submit(ruleForm) {
      this.btnLoading = true;
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          if (this.fileListOne.length === 0 || this.fileListTwo.length === 0) {
            this.$message({
              type: "error",
              message: "请上传ppt或excel",
              duration: 1000
            });
            this.btnLoading = false;
          } else {
            this.ruleForm.nominStandard = Number(this.stateType);
            this.ruleForm.nominType = Number(this.ruleForm.nominType);
            // if(!this.pptOaInfo?.fileName || !this.excelOainfo?.fileName) {
            //   this.btnLoading = false;
            //   return this.$message({type: "error", message: "oa接口异常，请联系oa人员", duration: 2000});
            // } 
            api
              .addOrUpdate({
                ...this.ruleForm,
                taskId: this.id,
                pptxName: this.lookPPTName,
                excelName: this.lookExcelName,
                // wjsc: [
                //   {
                //     ...this.pptOaInfo
                //   },
                //   {
                //     ...this.excelOainfo
                //   }
                // ]
              })
              .then(data => {
                console.log(data);
                this.btnLoading = false;
                this.$message({
                  type: "success",
                  message: "确认成功",
                  duration: 1000
                });
                setTimeout(() => {
                  this.$router.push({
                    path: "/mobile/medal/infoDetail",
                    query: {
                      isHR: this.isHR
                    }
                  });
                }, 1000);
              })
              .finally(() => {
                this.btnLoading = false;
              });
          }
        } else {
          this.btnLoading = false;
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #000;
  //   position: relative;
  .user-concent {
    flex: 1;
    position: relative;
    .con-top {
      width: 100%;
      height: 1300px;
      background: url("~@/assets/medal/newTask.jpg");
      background-size: 100% 100%;
    }
    .con-img-qua {
      position: absolute;
      top: 240px;
      width: 100%;
      text-align: center;
      img {
        width: 220px;
      }
      .title {
        font-family: PingFangSC, PingFang SC;
        width: 100%;
        background: linear-gradient(180deg, #fff3df 0%, #c6935a 100%);
        font-weight: bold;
        color: transparent;
        letter-spacing: 4px;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-size: 40px;
      }
      // font-size: 0.55rem;
      // color: #D7C4B7;
      // font-family: 'Microsoft YaHei';
    }
    .con-img-time {
      position: absolute;
      top: 1169px;
      width: 100%;
      text-align: center;
      font-size: 0.3rem;
      color: #000;
    }
    .con-content {
      margin-top: -30px;
      background: #fff;
      width: 100%;
      border-radius: 70px 70px 0 0;
      padding: 55px 30px 5px 30px;
      .download {
        // display: flex;
        // align-items: center;
        ::v-deep .el-form-item__content {
          line-height: 15px;
        }
        ::v-deep .el-form-item__label {
          margin-top: 0px;
        }
        div {
          display: flex;
          align-items: center;
          margin-left: 50px;
          img {
            width: 34px;
            height: 34px;
            margin-right: 10px;
          }
          span {
            font-size: 26px;
            color: rgba(78, 162, 124, 1);
            // margin-left: 450px;
            display: flex;
            align-items: center;
            margin-right: 10px * $zoom;
            // line-height: 40px;
          }
        }
      }
    }
  }
  .menu {
    width: 100%;
    height: 20px;
    background: rgb(243, 243, 245);
  }
  .foot-btn {
    height: 120px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 20px;
    .van-button {
      margin: 0 20px;
      border-radius: 15px;
      width: 300px;
    }
  }
}
.leading {
  div {
    display: flex;
    align-items: center;
  }
  ::v-deep {
    .van-button--primary {
      background: #fff;
      color: rgba(78, 162, 124, 1);
      border: 1px solid rgba(78, 162, 124, 1);
      border-radius: 10px;
      height: 70px;
      // float: left;
      width: 280px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .van-button__text{
      font-size: 24px;
    }
  }
  .leadingSpan {
    // float: right;
    // margin-top: 25px;
    margin-left: 40px;
    i {
      margin-left: 10px;
    }
    .a {
      color: skyblue;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
::v-deep {
  .el-form-item__label {
    font-size: 30px;
    color: black;
    line-height: 34px;
  }
  .van-cell {
    border: none;
    background: rgba(247, 249, 250, 1);
    height: 70px;
    line-height: 22px;
  }
  .el-input__inner {
    border: none;
    background: rgba(247, 249, 250, 1);
    height: 70px;
  }
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 45px;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: rgba(78, 162, 124, 1) !important;
    // border: rgba(78, 162, 124, 1) 1px solid;
  }
  .el-textarea__inner {
    height: 300px;
    background: rgba(247, 249, 250, 1);
    border: none;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    -webkit-box-shadow: -1px 0 0 0 rgb(78 162 124);
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-color: rgb(78 162 124);
  }
}
::v-deep {
  .el-select {
    width: 100%;
  }
}
.container_item {
  // background: #fff;
  margin-top: 20px;
  padding: 25px;
  .title {
    color: rgba(150, 155, 158, 1);
    font-size: 30px;
  }

  .handle {
    display: flex;
    margin-top: 10px;
    &:last-child {
      .handleDiv::after {
        width: 0;
        height: 0;
      }
    }
    .handleDiv::after {
      display: block;
      content: "";
      width: 1px;
      height: 70px;
      background-color: #ccc;
      position: relative;
      left: 24px;
    }

    .handleRight {
      margin-left: 20px;
      width: calc(100vh);
      .rightTitle {
        margin: 10px 0;
        font-size: 29px;
      }
      .approver {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        .approverImg {
          display: flex;
          flex-shrink: 0;
          align-items: center;
          .iconWrapper {
            position: relative;
            .elIcon {
              position: absolute;
              left: 40px;
              top: -10px;
              font-size: 22px;
            }
          }
          .clr-span {
            display: inline-block;
            border-radius: 20px;
            background-color: rgb(248 250 251);
            margin: 0 5px;
            padding: 10px 0;
            font-size: 24px;
            text-align: center;
            margin-left: 15px;
          }
        }
        .right {
          flex-shrink: 0;
          // margin-left: 30%;
          font-size: 22px;
          color: #9fa2a5;
        }
      }
    }
  }
}
</style>
